"use client"

import React from "react"

import { ConfirmationModal } from "features/common/ui/ConfirmationModal"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

import { useManageMembers } from "../../model/hooks/useManageMembers"

import { MemberList } from "./MemberList"

export const ManageMembers = () => {
  const { t } = useTranslation()
  const {
    teamMembers,
    isConfirmationModalOpen,
    selectedMember,
    showDeleteConfirmation,
    handleConfirmDelete,
    handleChangeRole,
    closeModal,
  } = useManageMembers()

  return (
    <SMembersContainer>
      <MemberList 
        teamMembers={teamMembers}
        onDelete={showDeleteConfirmation}
        onChangeRole={handleChangeRole}
      />

      <ConfirmationModal
        open={isConfirmationModalOpen}
        title={t('l_settings_removeMemberTitle', { name: selectedMember?.name })}
        description={t('l_settings_removeMemberMsg', { name: selectedMember?.name })}
        cancelText={t('a_common_cancel')}
        confirmText={t('a_common_remove')}
        confirmType="primary"
        confirmDanger={true}
        onCancel={closeModal}
        onConfirm={handleConfirmDelete}
      />
    </SMembersContainer>
  )
}

const SMembersContainer = styled.div`
  background: var(--color-white);
  padding: 16px 0;
  border-radius: 8px;
`
